export const navLinks = [
    { title: "News", url: "/Modules/news" },
    { title: "Events", url: "/arts-and-culture/calendar" },
    { title: "Careers", url: "/connect/careers" },
    { title: "Contact Us", url: "/connect/contact-us" }
];

export const myTownshipLink =  {
    title: "MyTownship",
    url: "/services/mytownship"
};

export const dropdownTitleToFeaturePageMap = {
    "Services": {
        className: "services",
        featurePageDescription: "How can we help?",
        featurePageUrl: "/services/report-a-problem.aspx",
        featurePageTitle: "Report a Problem"
    },
    "Parks & Recreation": {
        className: "parks-rec",
        featurePageDescription: "Discover our programs and activities for all ages.",
        featurePageUrl: "/parks-recreation/recreation-registration.aspx",
        featurePageTitle: "Recreation Registration"
    },
    "Arts & Culture": {
        className: "arts-culture",
        featurePageDescription: "Explore events in the Township",
        featurePageUrl: "/arts-culture/events.aspx",
        featurePageTitle: "Events"
    },
    "Building & Development": {
        className: "building-dev",
        featurePageDescription: "Access guides, policies, bylaws, forms, and other information.",
        featurePageUrl: "/building-development/development.aspx",
        featurePageTitle: "Development information"
    },
    "Connect": {
        className: "connect",
        featurePageDescription: "Explore our employment opportunities",
        featurePageUrl: "/connect/careers.aspx",
        featurePageTitle: "Careers"
    },
    "The Township": {
        className: "township",
        featurePageDescription: "Learn about and egage with us on a variety of topics.",
        featurePageUrl: "/connect/public-engagement-opportunities.aspx",
        featurePageTitle: "Public Engagement"
    }
};
